import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MbscModule } from '@mobiscroll/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { UploadComponentModule } from '../upload/upload.component.module';
import { OpenFormComponent } from './open-form.component';
import { QuillModule } from 'ngx-quill';
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		ReactiveFormsModule,
		NgSelectModule,
		MbscModule,
		UploadComponentModule,
		QuillModule.forRoot(),
	],
	declarations: [OpenFormComponent],
	exports: [OpenFormComponent],
})
export class OpenFormComponentModule {}
